



























































import store from '../../../store'
import DataTable from '../../../components/DataTable.vue'
import { stockCalculations } from '../../../mixins/mixins'
import PageTitle from '../../../components/PageTitle.vue'
import TableModal from '../../../components/TableModal.vue'
import Table13 from '../tables/Table13.vue'
import dayjs from 'dayjs'
const CODES = require('../../../data/Codes.json')

export default {
  mixins: [stockCalculations],
  data () {
    return {
      name: 'Scenario 1',
      date: dayjs().format('YYYY-MM-DD'),
      pasture: {
        currentFeed: 0,
        quality: null
      },
      stock: {
        type: null,
        weight: null,
        state: null,
        pregnancy: null,
        number: 0,
        daysGrazing: 0,
        intake: 0,
        energy: 0
      },
      supplement1: {
        type: null,
        grainForm: null,
        amount: 0,
        value: 0,
        nutrients: null,
        intake: 0
      },
      supplement2: {
        type: null,
        grainForm: null,
        amount: 0,
        value: 0,
        nutrients: null,
        intake: 0
      },
      theaders: [
        { text: 'Field', value: 'label' },
        { text: 'Ration', value: 'data.value' },
        { text: 'Status', value: 'notes.message' }
      ],

      // Feed Test Table
      feedTestItems: [
        { type: 'Wheat', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Barley', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Triticale', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Oats', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Lupins', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Peas', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Maize', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Safflower seeds', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Rice', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Rye', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Sorghum', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Pellets', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Grass hay', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Clover hay', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Lucerne', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Cereal', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Canola', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Grass silage', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Clover silage', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Lucerne silage', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Cereal silage', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Canola silage', drymatter: null, energy: null, protein: null, fibre: null },
        { type: 'Cereal straw', drymatter: null, energy: null, protein: null, fibre: null }
      ],
      feedTestHeaders: [
        { text: 'Suplement type', value: 'type' },
        { text: 'Dry matter %', value: 'drymatter' },
        { text: 'Energy (MJ ME/kf DM)', value: 'energy' },
        { text: 'Protein %', value: 'protein' },
        { text: 'Fibre (NDF) %', value: 'fibre' }
      ],
      table13: Table13
    }
  },

  // Populate on create if data exists
  created: function (this:any) {
    const stored = store.state.otherTools3
    if (stored !== null) {
      this.name = stored.name
      this.date = stored.date
      this.pasture = stored.pasture
      this.stock = stored.stock
      this.supplement1 = stored.supplement1
      this.supplement2 = stored.supplement2
      this.theaders = stored.theaders
      this.feedTestItems = stored.feedTestItems
      this.feedTestHeaders = stored.feedTestHeaders
    }
  },

  // Update state on component value changes
  updated: function (this:any) {
    store.dispatch('updateOtherTools3', this.$data)
  },

  // Update state on component destroy
  beforeDestroy: function (this:any) {
    store.dispatch('updateOtherTools3', this.$data)
  },

  computed: {
    tdata: {
      get: function (this:any) {
        let tdataArr:any = []

        // STOCK DETAILS

        let intakeEnergy = this.getPastureIntakeEnergy(this.stock)
        let stockArr:any[] = [
          {
            category: 'stock',
            code: 'type',
            label: 'Stock type',
            data: {
              display: 'select',
              type: 'string',
              value: this.stock.type,
              items: ['Cows', 'Weaner Cattle', 'Ewes / Wethers', 'Lambs']
            },
            notes: { message: null, link: null }
          },
          {
            category: 'stock',
            code: 'weight',
            label: 'Average weight',
            data: {
              display: 'select',
              type: 'string',
              value: this.stock.weight,
              items: this.getWeights(this.stock.type),
              suffix: 'kg/Hd'
            },
            notes: { message: null, link: null }
          },
          {
            category: 'stock',
            code: 'state',
            label: 'Physiological state',
            data: {
              display: 'select',
              type: 'string',
              value: this.stock.state,
              items: this.getPhysiologicalState(this.stock.type)
            },
            notes: { message: null, link: null }
          },
          {
            category: 'stock',
            code: 'pregnancy',
            label: 'Twins / singles / not applicable',
            data: {
              display: 'select',
              type: 'string',
              value: this.stock.pregnancy,
              items: this.stock.type === 'Ewes / Wethers' && this.stock.state !== 'Dry' ? ['Twins', 'Singles'] : ['Not Applicable']
            },
            notes: { message: null, link: null }
          },
          {
            category: 'stock',
            code: 'number',
            label: 'Number of animals grazing',
            data: {
              display: 'input',
              type: 'number',
              value: this.stock.number
            },
            notes: { message: null, link: null }
          },
          {
            category: 'stock',
            code: 'daysGrazing',
            label: 'Number of days on feed',
            data: {
              display: 'input',
              type: 'number',
              value: this.stock.daysGrazing
            },
            notes: { message: null, link: null }
          }
        ]

        // PASTURE DETAILS

        // Pasture % of intake
        let pasturePercentageIntake:number = 0
        if (this.stock.type && this.stock.weight && this.stock.state && this.pasture.currentFeed && this.pasture.quality) {
          let stockTypeCode:number = CODES.stocks.filter((s:any) => s.stock === this.stock.type)[0].code
          let stockWeightCode:number = 0
          CODES.weights.map((s:any) => {
            if (s.stock === this.stock.type) {
              s.weights.map((w:any) => {
                if (w.weight === this.stock.weight) {
                  stockWeightCode = w.code
                }
              })
            }
          })
          let stockStateCode:number = CODES.states.filter((s:any) => s.state === this.stock.state)[0].code
          let pastureAvailableCode:number = this.pasture.currentFeed < 1000 ? 500 : this.pasture.currentFeed < 1500 ? 600 : this.pasture.currentFeed < 2000 ? 700 : 800
          let pastureQualityCode:number = CODES.qualities.filter((q:any) => q.quality === this.pasture.quality)[0].code
          pasturePercentageIntake = stockTypeCode + stockWeightCode + stockStateCode + pastureAvailableCode + pastureQualityCode
          pasturePercentageIntake = CODES.totals.filter((t:any) => t.code === pasturePercentageIntake)[0].intake * 10
        }

        // Pasture energy intake
        let pastureEnergyIntake:number = intakeEnergy[0] * ((22.587 * this.pastureNutrients.digest) - 5.2361)

        let pastureArr:any[] = [
          {
            category: 'pasture',
            code: 'currentFeed',
            label: 'Current feed on offer (FOO)',
            data: {
              display: 'input',
              type: 'number',
              value: this.pasture.currentFeed,
              suffix: 'Kg DM/ha'
            },
            notes: { message: null, link: null }
          },
          {
            category: 'pasture',
            code: 'quality',
            label: 'Pasture quality',
            data: {
              display: 'select',
              type: 'string',
              value: this.pasture.quality,
              items: [
                '40% dig, 4.8 MJ ME/kg - Dry (Dead)',
                '50% dig, 6.5 MJ ME/kg - Dry, perennial',
                '60% dig, 8.2 MJ ME/kg  - Gone to seed',
                '70% dig, 10 MJ ME/kg - Green, grassy',
                '75% dig, 10.8 MJ ME/kg - Green, 15-30% clover',
                '80% dig - 11.6 MJ ME/kg - Green, 60% clover'
              ]
            },
            notes: { message: null, link: null }
          },
          {
            category: 'pasture',
            code: 'energyRequired',
            label: 'Maintenance energy required (MJ ME/Hd/day)',
            data: {
              display: 'text',
              type: 'number',
              value: intakeEnergy[1]
            },
            notes: { message: null, link: null }
          },
          {
            category: 'pasture',
            code: 'intake',
            label: 'Estimated pasture intake (kg DM/Hd/day)',
            data: {
              display: 'text',
              type: 'number',
              value: intakeEnergy[0]
            },
            notes: { message: null, link: null }
          },
          {
            category: 'pasture',
            code: 'ration',
            label: 'Pasture % of intake',
            data: {
              display: 'text',
              type: 'number',
              value: this.$options.filters.fixed(pasturePercentageIntake, 0)
            },
            notes: { message: null, link: null }
          },
          {
            category: 'pasture',
            code: 'energyIntake',
            label: 'Energy intake from pasture (MJME/Hd/Day)',
            data: {
              display: 'text',
              type: 'number',
              value: pastureEnergyIntake
            },
            notes: { message: null, link: null }
          },
          {
            category: 'pasture',
            code: 'protein',
            label: 'Protein % — pasture',
            data: {
              display: 'text',
              type: 'number',
              value: this.$options.filters.fixed(this.pastureNutrients.protein * 100, 0) + '%'
            },
            notes: { message: null, link: null }
          },
          {
            category: 'pasture',
            code: 'fibre',
            label: 'Fibre % — pasture',
            data: {
              display: 'text',
              type: 'number',
              value: this.$options.filters.fixed(this.pastureNutrients.fibre * 100, 0) + '%'
            },
            notes: { message: null, link: null }
          }
        ]

        // SUPPLEMENTS

        let supplementArr:any[] = []
        for (let i = 1; i <= 2; i++) {
          let currentSupplement = i === 1 ? this.supplement1 : this.supplement2
          let supplementNutrients = this.supplementNutrients(currentSupplement)
          currentSupplement.nutrients = supplementNutrients
          let supplementEnergyIntake = currentSupplement.nutrients.drymatter * (currentSupplement.grainForm === 'Whole' ? currentSupplement.nutrients.energyWhole : currentSupplement.nutrients.energyrolledMilled) * 10 * parseFloat(currentSupplement.amount)
          let hidden = i > 1

          let supplement = [
            {
              category: 'supplement ' + i,
              code: 'type',
              label: 'Supplement',
              data: {
                display: 'select',
                value: currentSupplement.type,
                items: ['Wheat', 'Barley', 'Triticale', 'Oats', 'Lupins', 'Peas', 'Maize', 'Safflower seeds',
                  'Rice', 'Rye', 'Sorghum', 'Pellets', 'Grass hay', 'Clover hay', 'Lucerne hay', 'Cereal hay', 'Canola hay',
                  'Grass silage', 'Clover silage', 'Lucerne silage', 'Cereal silage', 'Canola silage', 'Cereal straw']
              },
              notes: { message: null, link: null },
              hidden: hidden
            },
            {
              category: 'supplement ' + i,
              code: 'grainForm',
              label: 'Grain form',
              data: {
                display: 'select',
                value: currentSupplement.grainForm,
                items: ['Whole', 'Rolled or Milled']
              },
              notes: { message: null, link: null },
              hidden: hidden
            },
            {
              category: 'supplement ' + i,
              code: 'amount',
              label: 'Amount as fed',
              data: {
                display: 'input',
                type: 'number',
                value: currentSupplement.amount,
                suffix: 'Kg/Hd/Day'
              },
              notes: { message: null, link: null },
              hidden: hidden
            },
            {
              category: 'supplement ' + i,
              code: 'value',
              label: 'Value',
              data: {
                display: 'input',
                type: 'number',
                value: currentSupplement.value,
                prefix: '$',
                suffix: '/tonne'
              },
              notes: { message: null, link: null },
              hidden: hidden
            },
            {
              category: 'supplement ' + i,
              code: 'ration',
              label: 'Supplement ' + i + ' % of intake',
              data: {
                display: 'text',
                type: 'number',
                value: this.$options.filters.fixed((((currentSupplement.amount * currentSupplement.nutrients.drymatter * 10)) || 0), 0)
              },
              notes: { message: null, link: null },
              hidden: hidden
            },
            {
              category: 'supplement ' + i,
              code: 'energyIntake',
              label: 'Energy intake from supplement ' + i + ' (MJME/Hd/Day)',
              data: {
                display: 'text',
                type: 'number',
                value: supplementEnergyIntake
              },
              notes: { message: null, link: null },
              hidden: hidden
            },
            {
              category: 'supplement ' + i,
              code: 'protein',
              label: 'Protein % — supplement ' + i,
              data: {
                display: 'text',
                type: 'number',
                value: this.$options.filters.fixed(currentSupplement.nutrients.protein * 100, 2) + '%'
              },
              notes: { message: null, link: null },
              hidden: hidden
            },
            {
              category: 'supplement ' + i,
              code: 'fibre',
              label: 'Fibre % — supplement ' + i,
              data: {
                display: 'text',
                type: 'number',
                value: this.$options.filters.fixed(currentSupplement.nutrients.fibre * 100, 2) + '%'
              },
              notes: { message: null, link: null },
              hidden: hidden
            }
          ]
          supplementArr = supplementArr.concat(supplement)
        }

        // ENERGY, PROTEIN, & FIBRE

        let surplus = (this.totals.energy - intakeEnergy[1]) || 0
        let energyProtenFibreArr:any[] = [
          {
            category: 'Energy, protein & fibre',
            code: 'surplus',
            label: 'Energy surplus/deficit (MJME/Hd/Day)',
            data: {
              display: 'text',
              type: 'number',
              value: surplus
            },
            notes: { message: null, link: null }
          },
          {
            category: 'Energy, protein & fibre',
            code: 'totalProtein',
            label: 'Protein % of ration',
            data: {
              display: 'text',
              type: 'number',
              value: (this.$options.filters.fixed(this.totals.protein, 0) || 0) + '%'
            },
            notes: {
              message: this.totals.protein < this.pastureNutrients.protein ? 'Protein too low' : 'Sufficient protein',
              link: null
            }
          },
          {
            category: 'Energy, protein & fibre',
            code: 'totalFibre',
            label: 'Fibre % of ration',
            data: {
              display: 'text',
              type: 'number',
              value: (this.$options.filters.fixed(this.totals.fibre, 0) || 0) + '%'
            },
            notes: {
              message: this.totals.fibre < 30 ? 'Fibre too low' : this.totals.fibre < 50 ? 'Sufficient fibre' : this.totals.fibre >= 50 ? 'Reduce fibre intake' : '',
              link: null
            }
          }
        ]

        // DM INTAKE VS MAXIMUM DM INTAKE
        let doesNotApply = this.stock.type === 'Lambs' || (this.stock.type === 'Ewes / Wethers' && this.stock.state.includes('Lactating'))
        let maximumIntake = !doesNotApply ? this.stock.weight * (120 / this.totals.fibre) / 100 || 0 : '-'
        let dmIntakeArr:any[] = [
          {
            category: 'DM intake Vs maximum DM intake',
            code: 'totalIntake',
            label: 'Total intake (Kg DM/Hd/Day)',
            data: {
              display: 'text',
              type: 'number',
              value: this.totals.intake || 0
            },
            notes: {
              message: this.totals.intake > maximumIntake ? 'Ration exceeds possible intake. Reduce ration of place high fibre feed.' : '',
              link: null
            }
          },
          {
            category: 'DM intake Vs maximum DM intake',
            code: 'maximum',
            label: 'Estimated maximum intake (Kg DM/Hd/Day)',
            data: {
              display: 'text',
              type: 'number',
              value: maximumIntake
            },
            notes: {
              message: doesNotApply ? 'Max. intake calculation does not apply' : null,
              link: null
            }
          }
        ]

        // PREDICTED WEIGHT LOSS/GAIN OF STOCK

        let weightLossDaily = surplus / (surplus < 0 ? 28 : 35) * 1000
        let weightLossArr:any[] = [
          {
            category: 'Predicted weight loss / gain of stock',
            code: 'weightLossDaily',
            label: 'Predicted weight loss / gain (Grams/Hd/Day)',
            data: {
              display: 'text',
              type: 'number',
              value: this.$options.filters.fixed(weightLossDaily, 0) || 0
            },
            notes: { message: null, link: null }
          },
          {
            category: 'Predicted weight loss / gain of stock',
            code: 'weightLossTotal',
            label: 'Predicted weight loss / gain (Total Kg/Hd)',
            data: {
              display: 'text',
              type: 'number',
              value: this.$options.filters.fixed(((weightLossDaily / 1000) * this.stock.daysGrazing), 0) || 0
            },
            notes: { message: null, link: null }
          },
          {
            category: 'Predicted weight loss / gain of stock',
            code: 'weightAtEnd',
            label: 'Predicted weight at end feeding period (Kg/Hd)',
            data: {
              display: 'text',
              type: 'number',
              value: this.$options.filters.fixed((((weightLossDaily / 1000) * this.stock.daysGrazing)) + this.stock.weight, 0) || 0
            },
            notes: { message: null, link: null }
          }
        ]

        // COST OF RATION

        let costRationArr:any[] = []
        for (let i = 1; i <= 2; i++) {
          let currentSupplement = i === 1 ? this.supplement1 : this.supplement2
          let supplement = [
            {
              category: 'Cost of ration',
              code: 'supplementCost' + i,
              label: 'Supplement ' + i + ' (cents per MJ ME)',
              data: {
                display: 'text',
                type: 'number',
                value: ((currentSupplement.value * (10 / currentSupplement.nutrients.drymatter) / 1000) / (currentSupplement.grainForm === 'Whole' ? currentSupplement.nutrients.energyWhole : currentSupplement.nutrients.energyrolledMilled)) || 0
              },
              notes: { message: null, link: null },
              hidden: !currentSupplement.type
            }
          ]
          costRationArr = costRationArr.concat(supplement)
        }

        // TOTAL FEED REQUIRED AND COST

        let totalFeedCostArr:any[] = []
        for (let i = 1; i <= 2; i++) {
          let currentSupplement = i === 1 ? this.supplement1 : this.supplement2
          let supplement = [
            {
              category: 'Total feed required and cost',
              code: 'supplementTotalTonnes' + i,
              label: 'Total tonnes supplement ' + i,
              data: {
                display: 'text',
                type: 'number',
                value: ((this.stock.number * this.stock.daysGrazing * currentSupplement.amount) / 1000) || 0
              },
              notes: { message: null, link: null },
              hidden: !currentSupplement.type
            }
          ]
          totalFeedCostArr = totalFeedCostArr.concat(supplement)
        }
        let costOfRation = (this.supplement1.amount * this.stock.daysGrazing * (this.supplement1.value / 1000)) +
          (this.supplement2.amount * this.stock.daysGrazing * (this.supplement2.value / 1000))
        totalFeedCostArr = totalFeedCostArr.concat([
          {
            category: 'Total feed required and cost',
            code: 'costOfRation',
            label: 'Cost of ration ($/Hd)',
            data: {
              display: 'text',
              type: 'number',
              value: '$' + (this.$options.filters.fixed(costOfRation, 2) || 0)
            },
            notes: { message: null, link: null }
          },
          {
            category: 'Total feed required and cost',
            code: 'totalRationCost',
            label: 'Total ration cost',
            data: {
              display: 'text',
              type: 'number',
              value: '$' + (this.$options.filters.fixed(costOfRation * this.stock.number, 2) || 0)
            },
            notes: { message: null, link: null }
          }
        ])

        tdataArr = tdataArr.concat(stockArr, pastureArr, supplementArr, energyProtenFibreArr, dmIntakeArr, weightLossArr, costRationArr, totalFeedCostArr)
        return tdataArr
      },
      set: function (this:any, newValue:any) {
        // Filter each category into seperate array
        let stock = newValue.filter((e:any) => e.category === 'stock')
        let pasture = newValue.filter((e:any) => e.category === 'pasture')
        let supplement1 = newValue.filter((e:any) => e.category === 'supplement 1')
        let supplement2 = newValue.filter((e:any) => e.category === 'supplement 2')
        // Assign new value to category variables
        stock.forEach((e:any) => { this.stock[e.code] = e.data.value })
        pasture.forEach((e:any) => { this.pasture[e.code] = e.data.value })
        supplement1.forEach((e:any) => { this.supplement1[e.code] = e.data.value })
        supplement2.forEach((e:any) => { this.supplement2[e.code] = e.data.value })
      }
    },

    pastureNutrients: function (this:any) {
      let nutrients = { digest: 0, energy: 0, protein: 0, fibre: 0 }
      switch (this.pasture.quality) {
        case '40% dig, 4.8 MJ ME/kg - Dry (Dead)': nutrients = { digest: 0.4, energy: 4.8, protein: 0.06, fibre: 0.65 }; break
        case '50% dig, 6.5 MJ ME/kg - Dry, perennial': nutrients = { digest: 0.5, energy: 6.5, protein: 0.08, fibre: 0.55 }; break
        case '60% dig, 8.2 MJ ME/kg  - Gone to seed': nutrients = { digest: 0.6, energy: 8.2, protein: 0.11, fibre: 0.45 }; break
        case '70% dig, 10 MJ ME/kg - Green, grassy': nutrients = { digest: 0.7, energy: 10.0, protein: 0.18, fibre: 0.35 }; break
        case '75% dig, 10.8 MJ ME/kg - Green, 15-30% clover': nutrients = { digest: 0.75, energy: 10.8, protein: 0.23, fibre: 0.33 }; break
        case '80% dig - 11.6 MJ ME/kg - Green, 60% clover': nutrients = { digest: 0.8, energy: 11.6, protein: 0.28, fibre: 0.30 }; break
        default: break
      }
      return nutrients
    },

    totals: function (this:any) {
      let totalEnergy = 0
      let totalProtein = 0
      let totalFibre = 0
      let totalIntake = 0
      let intakeEnergy = this.getPastureIntakeEnergy(this.stock)

      // Add pasture values
      totalEnergy = (intakeEnergy[0] * ((22.587 * this.pastureNutrients.digest) - 5.2361))
      totalProtein = this.pastureNutrients.protein * this.pasture.ration
      totalFibre = this.pastureNutrients.fibre * this.pasture.ration
      totalIntake = intakeEnergy[0]

      // Add supplement values
      for (let i = 1; i <= 2; i++) {
        let currentSupplement = i === 1 ? this.supplement1 : this.supplement2
        if (currentSupplement.nutrients) {
          let supplementEnergyIntake = currentSupplement.nutrients.drymatter * (
            currentSupplement.grainForm === 'Whole' ? currentSupplement.nutrients.energyWhole : currentSupplement.nutrients.energyrolledMilled
          ) * 10 * parseFloat(currentSupplement.amount)
          totalEnergy += supplementEnergyIntake
          totalProtein += currentSupplement.nutrients.protein * currentSupplement.ration
          totalFibre += currentSupplement.nutrients.fibre * currentSupplement.ration
          totalIntake += (currentSupplement.nutrients.drymatter) * currentSupplement.amount
        }
      }
      totalProtein = (totalProtein / totalEnergy) * 100
      totalFibre = (totalFibre / totalEnergy) * 100

      return {
        energy: totalEnergy,
        protein: totalProtein,
        fibre: totalFibre,
        intake: totalIntake
      }
    }
  },

  methods: {
    // Get supplement nutrients
    supplementNutrients: function (this:any, supplement:any) {
      let nutrients = { drymatter: 0, energyWhole: 0, energyrolledMilled: 0, protein: 0, fibre: 0 }
      let custom = this.feedTestItems[this.feedTestItems.map((fti:any) => fti.type).indexOf(supplement.type)]
      // Custom values
      if (supplement.type !== null && parseInt(custom.drymatter) >= 0 && parseInt(custom.energy) >= 0 && parseInt(custom.protein) >= 0 && parseInt(custom.fibre) >= 0) {
        nutrients = {
          drymatter: custom.drymatter / 100,
          energyWhole: custom.energy / 100,
          energyrolledMilled: custom.energy / 100,
          protein: custom.protein / 100,
          fibre: custom.fibre / 100
        }
      // Averge values
      } else {
        switch (supplement.type) {
          case 'Wheat': nutrients = { drymatter: 0.90, energyWhole: 0.90, energyrolledMilled: 1.30, protein: 0.12, fibre: 0.10 }; break
          case 'Barley': nutrients = { drymatter: 0.90, energyWhole: 0.84, energyrolledMilled: 1.30, protein: 0.11, fibre: 0.10 }; break
          case 'Triticale': nutrients = { drymatter: 0.90, energyWhole: 1.04, energyrolledMilled: 1.30, protein: 0.12, fibre: 0.10 }; break
          case 'Oats': nutrients = { drymatter: 0.90, energyWhole: 1.00, energyrolledMilled: 1.10, protein: 0.09, fibre: 0.30 }; break
          case 'Lupins': nutrients = { drymatter: 0.90, energyWhole: 1.10, energyrolledMilled: 1.30, protein: 0.30, fibre: 0.10 }; break
          case 'Peas': nutrients = { drymatter: 0.90, energyWhole: 1.10, energyrolledMilled: 1.30, protein: 0.23, fibre: 0 }; break
          case 'Maize': nutrients = { drymatter: 0.90, energyWhole: 1.30, energyrolledMilled: 1.35, protein: 0.09, fibre: 0 }; break
          case 'Safflower seeds': nutrients = { drymatter: 0.90, energyWhole: 0, energyrolledMilled: 1.30, protein: 0.25, fibre: 0 }; break
          case 'Rice': nutrients = { drymatter: 0.90, energyWhole: 0, energyrolledMilled: 1.20, protein: 0.07, fibre: 0 }; break
          case 'Rye': nutrients = { drymatter: 0.90, energyWhole: 0, energyrolledMilled: 1.40, protein: 0.11, fibre: 0 }; break
          case 'Sorghum': nutrients = { drymatter: 0.90, energyWhole: 1.00, energyrolledMilled: 1.30, protein: 0.11, fibre: 0 }; break
          case 'Pellets': nutrients = { drymatter: 0.90, energyWhole: 0, energyrolledMilled: 1.20, protein: 0.12, fibre: 0.10 }; break
          case 'Grass hay': nutrients = { drymatter: 0.825, energyWhole: 0.9, energyrolledMilled: 0, protein: 0.085, fibre: 0.52 }; break
          case 'Clover hay': nutrients = { drymatter: 0.825, energyWhole: 0.9, energyrolledMilled: 0, protein: 0.13, fibre: 0.52 }; break
          case 'Lucerne hay': nutrients = { drymatter: 0.825, energyWhole: 0.85, energyrolledMilled: 0, protein: 0.145, fibre: 0.52 }; break
          case 'Cereal hay': nutrients = { drymatter: 0.825, energyWhole: 0.85, energyrolledMilled: 0, protein: 0.05, fibre: 0.52 }; break
          case 'Canola hay': nutrients = { drymatter: 0.825, energyWhole: 1.10, energyrolledMilled: 0, protein: 0.17, fibre: 0.52 }; break
          case 'Grass silage': nutrients = { drymatter: 0.825, energyWhole: 1.00, energyrolledMilled: 0, protein: 0.14, fibre: 0.54 }; break
          case 'Clover silage': nutrients = { drymatter: 0.825, energyWhole: 1.00, energyrolledMilled: 0, protein: 0.15, fibre: 0.43 }; break
          case 'Lucerne silage': nutrients = { drymatter: 0.825, energyWhole: 1.00, energyrolledMilled: 0, protein: 0.19, fibre: 0.43 }; break
          case 'Cereal silage': nutrients = { drymatter: 0.825, energyWhole: 0.90, energyrolledMilled: 0, protein: 0.11, fibre: 0.56 }; break
          case 'Canola silage': nutrients = { drymatter: 0.825, energyWhole: 0.90, energyrolledMilled: 0, protein: 0.17, fibre: 0.50 }; break
          case 'Cereal straw': nutrients = { drymatter: 0.825, energyWhole: 0.50, energyrolledMilled: 0, protein: 0.02, fibre: 0.60 }; break
          default: break
        }
      }
      return nutrients
    },

    // Update the tdata with new values
    update: function (this:any, row:any) {
      let updatedtData = this.tdata
      let oldRow = updatedtData.filter((e:any) => e.category === row.category && e.code === row.code)
      updatedtData[this.tdata.indexOf(oldRow[0])] = row
      this.tdata = updatedtData
      this.tdata.filter((e:any) => e.category === row.category).forEach((e:any) => { e.hidden = false })

      // Show applicable grain form options for selected supplement
      let grainFormSelect:any = []
      let noWhole = ['Safflower seeds', 'Rice', 'Rye', 'Pellets']
      let noRolledMilled = ['Grass hay', 'Clover hay', 'Lucerne hay', 'Cereal hay', 'Canola hay', 'Grass silage', 'Clover silage', 'Lucerne silage', 'Cereal silage', 'Canola silage', 'Cereal straw']
      if (noWhole.indexOf(row.data.value) < 0) {
        grainFormSelect.push('Whole')
      }
      if (noRolledMilled.indexOf(row.data.value) < 0) {
        grainFormSelect.push('Rolled or Milled')
      }
      this.tdata.filter((e:any) => e.category === row.category).forEach((e:any) => {
        if (e.code === 'grainForm') {
          e.data.items = grainFormSelect
        }
      })
    },

    // Load scenario data
    loadScenario: function (this:any, item:any) {
      this.tdata = item.data1
      this.feedTestItems = item.data2
    }
  },

  components: {
    DataTable, PageTitle, TableModal
  },

  store
}
